var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.842146cbf71c85e7b00b53c6ed5fdfc9.svg#g';
                    var viewUrl = 'sprites.842146cbf71c85e7b00b53c6ed5fdfc9.svg#view-g';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };